import React, { useState } from 'react'
import { useEffect } from 'react'
import { htmlToText, trimString, tokenAuthorize } from '../../components/Helpers/Common'
import { staticFiles } from '../../components/Helpers/Static';
import { serverUrl } from '../../components/Helpers/Config';
import axios from "axios";
import noprofile from "../../common/images-new/no-profile-pic.png";


function ProfileImage({ user_link }) {
    const [profile,setProfile] = useState(null)

    useEffect(()=>{
        let guid= user_link.replace('/profile/','');
        axios.get(serverUrl.ShowcaseGalleryImage + guid).then(res => {
            setProfile(res.data?.profile_image);
        }).catch(err => {
            tokenAuthorize(err?.response?.status);
            console.log(err)
          })
    },[user_link])

    return (
        <img className="w-10 h-10 object-cover rounded-full" alt="User avatar" src={profile ? profile : noprofile} />
    )
}

export default ProfileImage
